/**
 * Markdown-style links in FAQ answers (`[text](/path)`), without server
 * imports so the FAQ client can render them. Tokens are resolved to paths in
 * `faq-links.ts` before answers reach the page.
 */

export const FAQ_LINK = /\[([^\]]+)\]\(([^)\s]+)\)/g;

/** Plain text for structured data and anywhere links can't be shown. */
export function stripFaqLinks(text: string): string {
  return text.replace(FAQ_LINK, "$1");
}

export type FaqAnswerPart = { text: string; href?: string };

/** Split a resolved answer into text and link parts for rendering. */
export function splitFaqLinks(text: string): FaqAnswerPart[] {
  const parts: FaqAnswerPart[] = [];
  let last = 0;
  for (const match of text.matchAll(FAQ_LINK)) {
    const index = match.index ?? 0;
    if (index > last) parts.push({ text: text.slice(last, index) });
    parts.push({
      text: match[1],
      href: match[2].startsWith("/") ? match[2] : undefined,
    });
    last = index + match[0].length;
  }
  if (last < text.length) parts.push({ text: text.slice(last) });
  return parts;
}
